import { initializeApp } from "firebase/app";
import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
  } from "firebase/auth";
  import { getFirestore } from "firebase/firestore";
  import { firebaseApp } from "./firebase";

  const firebaseConfig = {
    apiKey: "AIzaSyB9hfxja1cJwzqnHhfneKExxhcEr43eBTw",
    authDomain: "pgkrm-87f65.firebaseapp.com",
    projectId: "pgkrm-87f65",
    storageBucket: "pgkrm-87f65.firebasestorage.app",
    messagingSenderId: "213561590083",
    appId: "1:213561590083:web:e0bec4b8d0f15e7361eff6",
    measurementId: "G-0NPBHT8DVC"
  };

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)

export const googleProvider = new GoogleAuthProvider();

export const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    console.log("Google User", user)

  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

export const logInWithEmailAndPassword = async (email, password) => {
    try {
      const user = await signInWithEmailAndPassword(auth, email, password);
      console.log("Login Email User", user.user)
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  export const registerWithEmailAndPassword = async (name, email, password) => {
    try {
      const res = await createUserWithEmailAndPassword(auth, email, password);
      const user = res.user;
      console.log("Register Email User", user)
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  export const sendPasswordReset = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset link sent!");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  export const logout = () => {
    signOut(auth);
  };

const db = getFirestore(app);

export { db };
